import store from "../store";
import ElementUI, {Loading} from "element-ui";
import {getAccessTokenByRefreshToken, getUserInfo, getUserInfoByAuthCode} from "./api";

export function cloneObj(obj) {
  var newJsonObj = {}
  newJsonObj = JSON.parse(JSON.stringify(obj))
  return newJsonObj
}


export function checkHasLogin() {
  return new Promise(resolve => {
    // 判断是否是第三方登录
    let authCode = getAuthCode()
    if (authCode == null || authCode == undefined) {
      store.commit('clearUserInfo');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('authCode')
      resolve(false)
    } else {
      getUserInfoByAuthCode().then(json => {
        store.commit('setUserInfo', json.data);
        store.commit('setLogin', true)
        localStorage.setItem("steamId",json.data.steamId)
        resolve(true)
      }).catch(e => {
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('authCode')
        localStorage.removeItem('steamId')
        store.commit('clearUserInfo');
        resolve(false)
      })
    }
  })
}

export function formatterTime(timestamp) {
  var date = new Date(timestamp); // 创建一个 Date 对象，并将时间戳作为参数传递
  var year = date.getFullYear(); // 获取年份
  var month = ('0' + (date.getMonth() + 1)).slice(-2); // 获取月份
  var day = ('0' + date.getDate()).slice(-2); // 获取日期
  var hours = ('0' + date.getHours()).slice(-2); // 获取小时
  var minutes = ('0' + date.getMinutes()).slice(-2); // 获取分钟
  var seconds = ('0' + date.getSeconds()).slice(-2); // 获取秒钟

// 拼接成字符串格式
  var dateString = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;

  return dateString
}

export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function formatterRarity(val) {
  switch (val) {
    case '消费级':
      return 'color: #b0c3d9;'
    case '军规级':
      return 'color: #4b69ff;'
    case '受限':
      return 'color: #8847ff;'
    case '保密':
      return 'color: #d32ce6;'
    case '隐秘':
      return 'color: #eb4b4b;'
    case '违禁':
      return 'color: #e4ae39;'
    case '非凡':
      return 'color: #eb4b4b;'
    case '卓越':
      return 'color: #8847ff;'
    case '奇异':
      return 'color: #d32ce6;'
    case '高级':
      return 'color: #4b69ff;'
    case '普通级':
      return 'color: #b0c3d9;'
    case '不朽':
      return 'color: #F2B166;'
    case '至宝':
      return 'color: #9ACC4C;'
    case '神话':
      return 'color: #A876F9;'
    case '珍稀':
      return 'color: #7C8FF5;'
    case '罕见':
      return 'color: #82BDFF;'
    default:
      return ''
  }
}


export function getRefreshToken() {
  let urlRefreshToken = new URL(window.location).searchParams.get('refresh_token')
  if (urlRefreshToken !== null && urlRefreshToken !== undefined) {
    localStorage.setItem('refresh_token', urlRefreshToken)
  }
  let refresh_token = localStorage.getItem('refresh_token') || urlRefreshToken;
  return refresh_token;
}

export function getAuthCode() {
// 使用正则表达式匹配authCode的值
  const match = window.location.href.match(/authCode=([^&]*)/);
  const urlAuthCode = match ? match[1] : null;

  if (urlAuthCode !== null && urlAuthCode !== undefined) {
    localStorage.setItem('authCode', urlAuthCode)
  }
  let authCode = localStorage.getItem('authCode') || urlAuthCode;
  return authCode;
}

export function getCookie() {
  return localStorage.getItem('cookies');
}

export function getSteamId() {
  return localStorage.getItem('steamId');
}

export function getSession() {
  return localStorage.getItem('session')
}

export const rarityOptions = [
  {
    rarityName: '消费级',
    rarity: 'Consumer Grade',
    color: '#b0c3d9'
  },
  {
    rarityName: '工业级',
    rarity: 'Industrial',
    color: '#5e98d9'
  },
  {
    rarityName: '军规级',
    rarity: 'Mil-Spec',
    color: '#4b69ff'
  },
  {
    rarityName: '受限',
    rarity: 'Restricted',
    color: '#8847ff'
  },
  {
    rarityName: '保密',
    rarity: 'Classified',
    color: '#d32ce6'
  },
  {
    rarityName: '隐秘',
    rarity: 'Covert',
    color: '#eb4b4b'
  },
  {
    rarityName: '普通级',
    rarity: 'Common',
    color: '#b0c3d9'
  },
  {
    rarityName: '高级',
    rarity: 'Rare',
    color: '#4b69ff'
  },
  {
    rarityName: '卓越',
    rarity: 'Mythical',
    color: '#8847ff'
  },
  {
    rarityName: '奇异',
    rarity: 'Legendary',
    color: '#d32ce6'
  },
  {
    rarityName: '非凡',
    rarity: 'Ancient',
    color: '#eb4b4b'
  }
]

export const rarityDic = {
  "消费级": "Consumer Grade",
  "工业级": "Industrial",
  "军规级": "Mil-Spec",
  "受限": "Restricted",
  "保密": "Classified",
  "隐秘": "Covert",
  "普通级": "Common",
  "高级": "Rare",
  "卓越": "Mythical",
  "奇异": "Legendary",
  "非凡": "Ancient"
}

export const rartiyIndex = {
  1: 'Consumer',
  2: 'Industrial',
  3: 'Mil-Spec',
  4: 'Restricted',
  5: 'Classified',
  6: 'Covert'
}

export const currencyIconOptions = {
  "CNY": "¥",
  'USD': "$",
  "AUD": "A$",
  "EUR": "€",
  "RUB": "₽",
  "TRY": "₺",
  "JPY": "¥",
  "HKD": "HK$",
  "CAD": "C$"
}

export const tradeUpRarityOptions = [
  {
    rarityName: '消费级',
    rarity: 'Consumer Grade',
    color: '#b0c3d9'
  },
  {
    rarityName: '工业级',
    rarity: 'Industrial',
    color: '#5e98d9'
  },
  {
    rarityName: '军规级',
    rarity: 'Mil-Spec',
    color: '#4b69ff'
  },
  {
    rarityName: '受限',
    rarity: 'Restricted',
    color: '#8847ff'
  },
  {
    rarityName: '保密',
    rarity: 'Classified',
    color: '#d32ce6'
  },
  {
    rarityName: '隐秘',
    rarity: 'Covert',
    color: '#eb4b4b'
  }
]

export const wearTypeOptions = [
  {optionKey: 'Factory New', optionValue: '崭新出厂', optionColor: 'background:#397439'},
  {optionKey: 'Minimal Wear', optionValue: '略有磨损', optionColor: 'background: #488B48'},
  {optionKey: 'Field-Tested', optionValue: '久经沙场', optionColor: 'background: #F1AD4D'},
  {optionKey: 'Well-Worn', optionValue: '破损不堪', optionColor: 'background: #B7625F'},
  {optionKey: 'Battle-Scarred', optionValue: '战痕累累', optionColor: 'background: #993A38'}
]

export const rarityLevelMapper = {
  1: 'Consumer Grade', // 消费级
  2: 'Industrial', // 工业级
  3: 'Mil-Spec', // 军规级
  4: 'Restricted', // 受限级
  5: 'Classified', // 保密
  6: 'Covert' // 隐秘
}

export function isEmpty(value) {
  // Check if the value is undefined, null, or an empty string
  return value === undefined || value === null || value === '';
}

export function formatterWear(val) {
  val = val.trim()
  val = val.replace('(', '')
  val = val.replace(')', '')
  switch (val) {
    case 'Factory New':
      return 'color:#397439'
    case 'Minimal Wear':
      return 'color: #488B48;'
    case 'Field-Tested':
      return 'color: #F1AD4D;'
    case 'Well-Worn':
      return 'color: #B7625F;'
    case 'Battle-Scarred':
      return 'color: #993A38;'
    default:
      return ''
  }
}

export function regexWear(engName) {
  let wearArr = engName.match(/\(([^)]*)\)/)
  if (wearArr !== null && wearArr.length != 0) {
    return wearArr[1]
  } else {
    return ''
  }
}

export const mockInventory = [
  {
    "rarityName": "隐秘",
    "commodity": 0,
    "market_tradable_restriction": 7,
    "avgPrice": null,
    "dmarketOrderUSDPrice": 91.71,
    "marketable": 1,
    "type": "★ 隐秘 匕首",
    "descriptions": [
      {
        "type": "html",
        "value": "外观： 战痕累累"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "color": "b0c3d9",
        "value": "名称标签：“sea”"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "type": "html",
        "value": "这把多功能战术匕首，采用骨头或纤维等粗糙材料打造成锯齿刀刃及一个锋利的穿肠钩。复合材料握把上还拴了带有六角螺母的刀片。 这把武器以交杂在一起的胶带为漏字板进行了喷漆。\n\n<i>真正的力量总是用精细的应用加以证明</i>"
      },
      {
        "type": "html",
        "value": " "
      }
    ],
    "uupinPrice": 633.39,
    "owner_descriptions": [
      {
        "type": "html",
        "value": " "
      },
      {
        "color": "ff4040",
        "type": "html",
        "value": "2024 10月 09 (7:00:00) 格林尼治标准时间 后可交易"
      }
    ],
    "engName": "★ Survival Knife | Urban Masked (Battle-Scarred)",
    "steamBuyerPrice": 832.9,
    "currency": 0,
    "name_color": "8650AC",
    "minPlatform": "UU",
    "iconUrl": "https://community.cloudflare.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpovbSsLQJf0PLGeC59_8yJgIGbksjhIbnQmFRZ7cRnk6fC8Nin3QWyr0dlYjjwJIXAIwU7MlqE-VnqwrrtjcC96c6dnydquSAl-z-DyN23O9yF",
    "dmarketPrice": 755.9983476976287,
    "icon_url": "https://community.cloudflare.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpovbSsLQJf0PLGeC59_8yJgIGbksjhIbnQmFRZ7cRnk6fC8Nin3QWyr0dlYjjwJIXAIwU7MlqE-VnqwrrtjcC96c6dnydquSAl-z-DyN23O9yF",
    "c5Price": 650,
    "staffGame": "csgo",
    "disCount": 0.6736901444404263,
    "market_actions": [
      {
        "link": "steam://rungame/730/76561202255233023/+csgo_econ_action_preview%20M%listingid%A%assetid%D17162669475534121362",
        "name": "在游戏中检视…"
      }
    ],
    "maxPlatform": "IGXE",
    "market_hash_name": "★ Survival Knife | Urban Masked (Battle-Scarred)",
    "weaponCase": null,
    "market_name": "★ Survival Knife | Urban Masked (Battle-Scarred)",
    "steamSellerPrice": 940.18,
    "tags": [
      {
        "internal_name": "CSGO_Type_Knife",
        "localized_category_name": "类型",
        "localized_tag_name": "匕首",
        "category": "Type"
      },
      {
        "internal_name": "weapon_knife_canis",
        "localized_category_name": "武器",
        "localized_tag_name": "求生匕首",
        "category": "Weapon"
      },
      {
        "internal_name": "set_community_23",
        "localized_category_name": "收藏品",
        "localized_tag_name": "“裂网大行动”收藏品",
        "category": "ItemSet"
      },
      {
        "internal_name": "unusual",
        "localized_category_name": "类别",
        "color": "8650AC",
        "localized_tag_name": "★",
        "category": "Quality"
      },
      {
        "internal_name": "Rarity_Ancient_Weapon",
        "localized_category_name": "品质",
        "color": "eb4b4b",
        "localized_tag_name": "隐秘",
        "category": "Rarity"
      },
      {
        "internal_name": "WearCategory4",
        "localized_category_name": "外观",
        "localized_tag_name": "战痕累累",
        "category": "Exterior"
      }
    ],
    "unstable": 0,
    "dmarketOrderPrice": 642.09,
    "classid": "6192079431",
    "igxePrice": 800,
    "instanceid": "5836557802",
    "background_color": "",
    "buffPrice": 634,
    "cnName": "求生匕首（★） | 都市伪装 (战痕累累)",
    "appid": 730,
    "minPrice": 633.39,
    "tradable": 0,
    "name": "求生匕首（★） | 都市伪装",
    "steamSafeBuyerPrice": 831.85,
    "maxPrice": 800,
    "actions": [
      {
        "link": "steam://rungame/730/76561202255233023/+csgo_econ_action_preview%20S%owner_steamid%A%assetid%D17162669475534121362",
        "name": "在游戏中检视…"
      }
    ],
    "rarity": "Covert"
  },
  {
    "rarityName": "军规级",
    "commodity": 0,
    "market_tradable_restriction": 7,
    "avgPrice": 11.59,
    "dmarketOrderUSDPrice": 1,
    "marketable": 1,
    "type": "StatTrak™ 军规级 手枪",
    "descriptions": [
      {
        "type": "html",
        "value": "外观： 略有磨损"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "color": "99ccff",
        "type": "html",
        "value": "该物品具有 StatTrak™ 技术，在其所有者装备时能跟踪若干统计数据。"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "color": "CF6A32",
        "type": "html",
        "value": "该物品记录已认证杀敌数。"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "type": "html",
        "value": "两把具有大弹匣的贝瑞塔同时开火会降低精准度，并增加换弹时间。不过你得往好处想，这不，别人只有一把枪，而你可以同时用两把贝瑞塔射个痛快。 这把武器的滑套和枪管上有着激光蚀刻的巨龙。\n\n<i>玛丽亚总是比西尔维娅更酷</i>"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "color": "9da1a9",
        "type": "html",
        "value": "暗影收藏品"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "type": "html",
        "value": "<br><div id=\"sticker_info\" name=\"sticker_info\" title=\"印花\" style=\"border: 2px solid rgb(102, 102, 102); border-radius: 6px; width=100; margin:4px; padding:8px;\"><center><img width=64 height=48 src=\"https://steamcdn-a.akamaihd.net/apps/730/icons/econ/stickers/rio2022/gray_holo.ff8f567c3ea3abd357b82a15e51baa7fe0b98c5a.png\"><img width=64 height=48 src=\"https://steamcdn-a.akamaihd.net/apps/730/icons/econ/stickers/bf2042/ptfo_holo.8685b4fd687145fd8b6e5ecc1cb2963bcebc51e9.png\"><br>印花: Grayhound Gaming（全息）| 2022年里约热内卢锦标赛, PTFO（全息）</center></div>"
      }
    ],
    "uupinPrice": 9.1,
    "owner_descriptions": [
      {
        "type": "html",
        "value": " "
      },
      {
        "color": "ff4040",
        "type": "html",
        "value": "2024 10月 09 (7:00:00) 格林尼治标准时间 后可交易"
      }
    ],
    "engName": "StatTrak™ Dual Berettas | Dualing Dragons (Minimal Wear)",
    "steamBuyerPrice": 11.4,
    "currency": 0,
    "name_color": "CF6A32",
    "minPlatform": "UU",
    "iconUrl": "https://community.cloudflare.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpos7asPwJf0Ob3dShD4N6zhpKOg-P1DL_Dl2xe5tZOhuDG_Zi72wfg-Uo4MT-lI4WRclM-NQrR-Qfswb_t1JLquJqcwCdnviEq4yyImQv3308f0mnbxg",
    "dmarketPrice": 8.33152466901443,
    "icon_url": "https://community.cloudflare.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpos7asPwJf0Ob3dShD4N6zhpKOg-P1DL_Dl2xe5tZOhuDG_Zi72wfg-Uo4MT-lI4WRclM-NQrR-Qfswb_t1JLquJqcwCdnviEq4yyImQv3308f0mnbxg",
    "c5Price": 10.42,
    "staffGame": "csgo",
    "disCount": 0.7954545454545454,
    "market_actions": [
      {
        "link": "steam://rungame/730/76561202255233023/+csgo_econ_action_preview%20M%listingid%A%assetid%D2314934780279801040",
        "name": "在游戏中检视…"
      }
    ],
    "maxPlatform": "C5Game",
    "market_hash_name": "StatTrak™ Dual Berettas | Dualing Dragons (Minimal Wear)",
    "weaponCase": "暗影收藏品",
    "market_name": "StatTrak™ Dual Berettas | Dualing Dragons (Minimal Wear)",
    "steamSellerPrice": 11.44,
    "tags": [
      {
        "internal_name": "CSGO_Type_Pistol",
        "localized_category_name": "类型",
        "localized_tag_name": "手枪",
        "category": "Type"
      },
      {
        "internal_name": "weapon_elite",
        "localized_category_name": "武器",
        "localized_tag_name": "双持贝瑞塔",
        "category": "Weapon"
      },
      {
        "internal_name": "set_community_9",
        "localized_category_name": "收藏品",
        "localized_tag_name": "暗影收藏品",
        "category": "ItemSet"
      },
      {
        "internal_name": "strange",
        "localized_category_name": "类别",
        "color": "CF6A32",
        "localized_tag_name": "StatTrak™",
        "category": "Quality"
      },
      {
        "internal_name": "Rarity_Rare_Weapon",
        "localized_category_name": "品质",
        "color": "4b69ff",
        "localized_tag_name": "军规级",
        "category": "Rarity"
      },
      {
        "internal_name": "WearCategory1",
        "localized_category_name": "外观",
        "localized_tag_name": "略有磨损",
        "category": "Exterior"
      },
      {
        "internal_name": "Tournament20",
        "localized_category_name": "锦标赛",
        "localized_tag_name": "2022年 IEM 里约锦标赛",
        "category": "Tournament"
      },
      {
        "internal_name": "Team86",
        "localized_category_name": "战队",
        "localized_tag_name": "Grayhound Gaming",
        "category": "TournamentTeam"
      }
    ],
    "dmarketOrderPrice": 7,
    "unstable": 0,
    "classid": "6192141738",
    "igxePrice": 9.14,
    "instanceid": "188530170",
    "background_color": "",
    "cnName": "双持贝瑞塔（StatTrak™） | 龙之双子 (略有磨损)",
    "buffPrice": 9.75,
    "appid": 730,
    "minPrice": 9.1,
    "tradable": 0,
    "name": "双持贝瑞塔（StatTrak™） | 龙之双子",
    "steamSafeBuyerPrice": 11.27,
    "maxPrice": 10.42,
    "actions": [
      {
        "link": "steam://rungame/730/76561202255233023/+csgo_econ_action_preview%20S%owner_steamid%A%assetid%D2314934780279801040",
        "name": "在游戏中检视…"
      }
    ],
    "rarity": "Mil-Spec"
  },
  {
    "rarityName": "高级",
    "commodity": 1,
    "market_tradable_restriction": 7,
    "avgPrice": 15.8,
    "dmarketOrderUSDPrice": 0.27,
    "marketable": 1,
    "type": "高级 印花",
    "descriptions": [
      {
        "color": "ffd700",
        "type": "html",
        "value": "该物品用于纪念 2019 年 IEM 卡托维兹 CS:GO 锦标赛。"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "type": "html",
        "value": "这张印花可以应用在您所拥有的任何武器上，您也可以刮掉它，使其显得更为老旧。您可以多次刮除同一张印花，刮得次数越多，磨损程度越大。直到您将其完全从武器上刮去为止。"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "type": "html",
        "value": "这张印花由2019年卡托维兹锦标赛中 Fnatic 战队的职业选手 Simon Eliasson 亲笔签名。\n\n销售此印花的 50% 所得部分款项将用于支持该印花的选手和俱乐部。"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "color": "00a000",
        "type": "html",
        "value": ""
      }
    ],
    "uupinPrice": 16.66,
    "owner_descriptions": [
      {
        "type": "html",
        "value": " "
      },
      {
        "color": "ff4040",
        "type": "html",
        "value": "2024 10月 09 (7:00:00) 格林尼治标准时间 后可交易"
      }
    ],
    "engName": "Sticker | twist | Katowice 2019",
    "steamBuyerPrice": 4.06,
    "currency": 0,
    "name_color": "D2D2D2",
    "minPlatform": "BUFF",
    "iconUrl": "https://community.cloudflare.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXQ9QVcJY8gulRWTVjfUO2u0p2DAgQ7Ng1Qia6yIhR0nfGRImobu4XikIHTz6LyYOOJxTxV6sYg07DEpYmjiVLi-kM4ZzyiItSLMlhpnmLAjVE",
    "dmarketPrice": null,
    "icon_url": "https://community.cloudflare.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXQ9QVcJY8gulRWTVjfUO2u0p2DAgQ7Ng1Qia6yIhR0nfGRImobu4XikIHTz6LyYOOJxTxV6sYg07DEpYmjiVLi-kM4ZzyiItSLMlhpnmLAjVE",
    "c5Price": 25,
    "staffGame": "csgo",
    "disCount": 0.6297229219143576,
    "market_actions": [
      {
        "link": "steam://rungame/730/76561202255233023/+csgo_econ_action_preview%20M%listingid%A%assetid%D11539611119441769997",
        "name": "在游戏中检视…"
      }
    ],
    "maxPlatform": "C5Game",
    "market_hash_name": "Sticker | twist | Katowice 2019",
    "weaponCase": "2019年卡托维兹锦标赛选手亲笔签名",
    "market_name": "Sticker | twist | Katowice 2019",
    "steamSellerPrice": 15.88,
    "tags": [
      {
        "internal_name": "CSGO_Tool_Sticker",
        "localized_category_name": "类型",
        "localized_tag_name": "印花",
        "category": "Type"
      },
      {
        "internal_name": "normal",
        "localized_category_name": "类别",
        "localized_tag_name": "普通",
        "category": "Quality"
      },
      {
        "internal_name": "Rarity_Rare",
        "localized_category_name": "品质",
        "color": "4b69ff",
        "localized_tag_name": "高级",
        "category": "Rarity"
      },
      {
        "internal_name": "PlayerSignature",
        "localized_category_name": "印花类型",
        "localized_tag_name": "选手亲笔签名",
        "category": "StickerCategory"
      },
      {
        "internal_name": "Tournament15",
        "localized_category_name": "锦标赛",
        "localized_tag_name": "2019 IEM 卡托维兹",
        "category": "Tournament"
      },
      {
        "internal_name": "Team6",
        "localized_category_name": "战队",
        "localized_tag_name": "Fnatic",
        "category": "TournamentTeam"
      },
      {
        "internal_name": "twist",
        "localized_category_name": "职业选手",
        "localized_tag_name": "Twist（Simon Eliasson）",
        "category": "ProPlayer"
      },
      {
        "internal_name": "crate_signature_pack_katowice2019_group_players_collection",
        "localized_category_name": "印花收藏品",
        "localized_tag_name": "2019年卡托维兹锦标赛选手亲笔签名",
        "category": "StickerCapsule"
      }
    ],
    "unstable": 0,
    "dmarketOrderPrice": 1.89,
    "classid": "6192072786",
    "igxePrice": 15,
    "instanceid": "188530139",
    "background_color": "",
    "cnName": "印花 | twist | 2019年卡托维兹锦标赛",
    "buffPrice": 10,
    "appid": 730,
    "minPrice": 10,
    "tradable": 0,
    "name": "印花 | twist | 2019年卡托维兹锦标赛",
    "steamSafeBuyerPrice": 3.95,
    "maxPrice": 25,
    "actions": [
      {
        "link": "steam://rungame/730/76561202255233023/+csgo_econ_action_preview%20S%owner_steamid%A%assetid%D11539611119441769997",
        "name": "在游戏中检视…"
      }
    ],
    "rarity": "Rare"
  },
  {
    "rarityName": "受限",
    "commodity": 0,
    "market_tradable_restriction": 7,
    "avgPrice": 54.8,
    "dmarketOrderUSDPrice": 5.14,
    "marketable": 1,
    "type": "受限 霰弹枪",
    "descriptions": [
      {
        "type": "html",
        "value": "外观： 战痕累累"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "type": "html",
        "value": "反恐精英专用的 Mag-7 带来毁灭性的近距离杀伤力。它快速的弹仓式装弹方式使其成为一个不错的战术选择。 这把武器的部分零件以黄色生产线的配色方案进行了整体喷漆。\n\n<i>这把碎骨器是个毁灭者</i>"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "color": "9da1a9",
        "type": "html",
        "value": "荒漠迷城收藏品"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "type": "html",
        "value": "<br><div id=\"sticker_info\" name=\"sticker_info\" title=\"印花\" style=\"border: 2px solid rgb(102, 102, 102); border-radius: 6px; width=100; margin:4px; padding:8px;\"><center><img width=64 height=48 src=\"https://steamcdn-a.akamaihd.net/apps/730/icons/econ/stickers/antwerp2022/navi.5c852c744ca93772a4f442cd88c7ea3d15fb236c.png\"><img width=64 height=48 src=\"https://steamcdn-a.akamaihd.net/apps/730/icons/econ/stickers/antwerp2022/navi.5c852c744ca93772a4f442cd88c7ea3d15fb236c.png\"><img width=64 height=48 src=\"https://steamcdn-a.akamaihd.net/apps/730/icons/econ/stickers/antwerp2022/navi.5c852c744ca93772a4f442cd88c7ea3d15fb236c.png\"><img width=64 height=48 src=\"https://steamcdn-a.akamaihd.net/apps/730/icons/econ/stickers/antwerp2022/navi.5c852c744ca93772a4f442cd88c7ea3d15fb236c.png\"><br>印花: Natus Vincere | 2022年安特卫普锦标赛, Natus Vincere | 2022年安特卫普锦标赛, Natus Vincere | 2022年安特卫普锦标赛, Natus Vincere | 2022年安特卫普锦标赛</center></div>"
      }
    ],
    "uupinPrice": 59.89,
    "owner_descriptions": [
      {
        "type": "html",
        "value": " "
      },
      {
        "color": "ff4040",
        "type": "html",
        "value": "2024 10月 09 (7:00:00) 格林尼治标准时间 后可交易"
      }
    ],
    "engName": "MAG-7 | Bulldozer (Battle-Scarred)",
    "steamBuyerPrice": 55.36,
    "currency": 0,
    "name_color": "D2D2D2",
    "minPlatform": "BUFF",
    "iconUrl": "https://community.cloudflare.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7uifDhz3MzRdDFO48uJnIWKge66YO7QwG1Vusch2LiSpdX02gXs-kVqZGrycYPBd1VvYwzTrwXrx7vs04j84spsYtOhxQ",
    "dmarketPrice": 55.9402370633826,
    "icon_url": "https://community.cloudflare.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpou7uifDhz3MzRdDFO48uJnIWKge66YO7QwG1Vusch2LiSpdX02gXs-kVqZGrycYPBd1VvYwzTrwXrx7vs04j84spsYtOhxQ",
    "c5Price": 52.35,
    "staffGame": "csgo",
    "disCount": 0.9300661777857271,
    "market_actions": [
      {
        "link": "steam://rungame/730/76561202255233023/+csgo_econ_action_preview%20M%listingid%A%assetid%D2488320607983450813",
        "name": "在游戏中检视…"
      }
    ],
    "maxPlatform": "UU",
    "market_hash_name": "MAG-7 | Bulldozer (Battle-Scarred)",
    "weaponCase": "荒漠迷城收藏品",
    "market_name": "MAG-7 | Bulldozer (Battle-Scarred)",
    "steamSellerPrice": 55.91,
    "tags": [
      {
        "internal_name": "CSGO_Type_Shotgun",
        "localized_category_name": "类型",
        "localized_tag_name": "霰弹枪",
        "category": "Type"
      },
      {
        "internal_name": "weapon_mag7",
        "localized_category_name": "武器",
        "localized_tag_name": "MAG-7",
        "category": "Weapon"
      },
      {
        "internal_name": "set_mirage",
        "localized_category_name": "收藏品",
        "localized_tag_name": "荒漠迷城收藏品",
        "category": "ItemSet"
      },
      {
        "internal_name": "normal",
        "localized_category_name": "类别",
        "localized_tag_name": "普通",
        "category": "Quality"
      },
      {
        "internal_name": "Rarity_Mythical_Weapon",
        "localized_category_name": "品质",
        "color": "8847ff",
        "localized_tag_name": "受限",
        "category": "Rarity"
      },
      {
        "internal_name": "WearCategory4",
        "localized_category_name": "外观",
        "localized_tag_name": "战痕累累",
        "category": "Exterior"
      },
      {
        "internal_name": "Tournament19",
        "localized_category_name": "锦标赛",
        "localized_tag_name": "2022 PGL 安特卫普",
        "category": "Tournament"
      },
      {
        "internal_name": "Team12",
        "localized_category_name": "战队",
        "localized_tag_name": "Natus Vincere",
        "category": "TournamentTeam"
      }
    ],
    "unstable": 0,
    "dmarketOrderPrice": 35.99,
    "classid": "6192072361",
    "igxePrice": null,
    "instanceid": "0",
    "background_color": "",
    "cnName": "MAG-7 | 威吓者 (战痕累累)",
    "buffPrice": 52,
    "appid": 730,
    "minPrice": 52,
    "tradable": 0,
    "name": "MAG-7 | 威吓者",
    "steamSafeBuyerPrice": 54.16,
    "maxPrice": 59.89,
    "actions": [
      {
        "link": "steam://rungame/730/76561202255233023/+csgo_econ_action_preview%20S%owner_steamid%A%assetid%D2488320607983450813",
        "name": "在游戏中检视…"
      }
    ],
    "rarity": "Restricted"
  },
  {
    "rarityName": "军规级",
    "commodity": 0,
    "market_tradable_restriction": 7,
    "avgPrice": 25.35,
    "dmarketOrderUSDPrice": 2.59,
    "marketable": 1,
    "type": "军规级 手枪",
    "descriptions": [
      {
        "type": "html",
        "value": "外观： 久经沙场"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "type": "html",
        "value": "从《反恐精英：起源》中穿越而来，是玩家们的最爱，消音版 USP 手枪装有一个可拆卸的消音器，降低后坐力的同时还能抑制住容易引起注意的枪声。 这把武器使用丛林虎的花纹进行了涂装。"
      },
      {
        "type": "html",
        "value": " "
      },
      {
        "color": "9da1a9",
        "type": "html",
        "value": "电竞 2014 夏季收藏品"
      },
      {
        "type": "html",
        "value": " "
      }
    ],
    "uupinPrice": 17.28,
    "owner_descriptions": [
      {
        "type": "html",
        "value": " "
      },
      {
        "color": "ff4040",
        "type": "html",
        "value": "2024 10月 09 (7:00:00) 格林尼治标准时间 后可交易"
      }
    ],
    "engName": "USP-S | Blood Tiger (Field-Tested)",
    "steamBuyerPrice": 25.58,
    "currency": 0,
    "name_color": "D2D2D2",
    "minPlatform": "UU",
    "iconUrl": "https://community.cloudflare.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoo6m1FBRp3_bGcjhQ09Svq5KOk-P9NL7DqWZU7Mxkh6eQotil2g3s8kNkYTqiJtTEJ1A-ZA2Gr1i4lbjqgcS9u5jImyYwsyEr-z-DyHMYUOhp",
    "dmarketPrice": 20.23370276760647,
    "icon_url": "https://community.cloudflare.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DEVlxkKgpoo6m1FBRp3_bGcjhQ09Svq5KOk-P9NL7DqWZU7Mxkh6eQotil2g3s8kNkYTqiJtTEJ1A-ZA2Gr1i4lbjqgcS9u5jImyYwsyEr-z-DyHMYUOhp",
    "c5Price": 20.12,
    "staffGame": "csgo",
    "disCount": 0.6736842105263159,
    "market_actions": [
      {
        "link": "steam://rungame/730/76561202255233023/+csgo_econ_action_preview%20M%listingid%A%assetid%D7064707481596443439",
        "name": "在游戏中检视…"
      }
    ],
    "maxPlatform": "IGXE",
    "market_hash_name": "USP-S | Blood Tiger (Field-Tested)",
    "weaponCase": "电竞 2014 夏季收藏品",
    "market_name": "USP-S | Blood Tiger (Field-Tested)",
    "steamSellerPrice": 25.65,
    "tags": [
      {
        "internal_name": "CSGO_Type_Pistol",
        "localized_category_name": "类型",
        "localized_tag_name": "手枪",
        "category": "Type"
      },
      {
        "internal_name": "weapon_usp_silencer",
        "localized_category_name": "武器",
        "localized_tag_name": "USP 消音版",
        "category": "Weapon"
      },
      {
        "internal_name": "set_esports_iii",
        "localized_category_name": "收藏品",
        "localized_tag_name": "电竞 2014 夏季收藏品",
        "category": "ItemSet"
      },
      {
        "internal_name": "normal",
        "localized_category_name": "类别",
        "localized_tag_name": "普通",
        "category": "Quality"
      },
      {
        "internal_name": "Rarity_Rare_Weapon",
        "localized_category_name": "品质",
        "color": "4b69ff",
        "localized_tag_name": "军规级",
        "category": "Rarity"
      },
      {
        "internal_name": "WearCategory2",
        "localized_category_name": "外观",
        "localized_tag_name": "久经沙场",
        "category": "Exterior"
      }
    ],
    "unstable": 0,
    "dmarketOrderPrice": 18.13,
    "classid": "6192071559",
    "igxePrice": 28.5,
    "instanceid": "188530139",
    "background_color": "",
    "buffPrice": 18.15,
    "cnName": "USP 消音版 | 血虎 (久经沙场)",
    "appid": 730,
    "minPrice": 17.28,
    "tradable": 0,
    "name": "USP 消音版 | 血虎",
    "steamSafeBuyerPrice": 25.5,
    "maxPrice": 28.5,
    "actions": [
      {
        "link": "steam://rungame/730/76561202255233023/+csgo_econ_action_preview%20S%owner_steamid%A%assetid%D7064707481596443439",
        "name": "在游戏中检视…"
      }
    ],
    "rarity": "Mil-Spec"
  }
]



// WEBPACK FOOTER //
// ./src/api/util.js